<template>
  <div id="XSFooter">
    <nav id="xs-navs-foot">
      <router-link :class="{selected: $route.name === 'index'}" tag="span" to="/">首页</router-link>
      <router-link :class="{selected: $route.name === 'product'}" tag="span" to="/product">产品</router-link>
      <router-link :class="{selected: $route.name === 'opportunity'}" tag="span" to="/opportunity">行业机会</router-link>
      <router-link :class="{selected: $route.name === 'solution'}" tag="span" to="/solution">解决方案</router-link>
      <router-link :class="{selected: $route.name === 'business'}" tag="span" to="/business">商务合作</router-link>
      <router-link :class="{selected: $route.name === 'technique'}" tag="span" to="/technique">技术优势</router-link>
      <router-link :class="{selected: $route.name === 'project'}" tag="span" to="/project">项目介绍</router-link>
      <span class="lawmsg qrcode">
        <img src="../assets/qrCode.png" alt="">
        <div>弦熵科技公众号</div>
      </span>
      <span class="lawmsg">400-837-6686</span>
      <span class="lawmsg">bd@entropy.biz</span>
      <span class="lawmsg"><a href="https://beian.miit.gov.cn">津ICP备18008783号-1</a></span>
    </nav>
  </div>
</template>
<script>
export default {
  name: 'XSFooter'
}
</script>
<style lang="scss">
  #XSFooter {
    #xs-navs-foot {
      color: #333;
      width: 100%;
      position: fixed;
      bottom: 0px;
      left: 20px;
      text-align: center;
      padding: 20px;
      min-width: 1280px;
      span {
        float: left;
        position: relative;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        padding: 0px;
        margin: 0 1%;
        display: inline-block;
        vertical-align: top;
        cursor: pointer!important;
      }
      span:hover {
        color: #3692fb;
      }
      .lawmsg {
        float: right;
        margin-left: 5px;
        cursor: default!important;
      }
      .lawmsg:nth-child(9){
        margin-right: 10%;
      }
      .qrcode {
        margin-top: -61px;
        margin-right: 3%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/XsFooter.vue